// Sentry browser error monitoring.
// No-op when REACT_APP_SENTRY_DSN is unset, so dev/preview without the env var
// behaves exactly as before. Imported first in index.js so it initialises early.
import * as Sentry from '@sentry/react';
import { APP_VERSION } from '@/lib/appVersion';

const dsn = process.env.REACT_APP_SENTRY_DSN;

// Decided at runtime: the build is the same for preview and production, so a build-time
// variable tagged production errors "preview" (HAL-FRONTEND-Z). The env var only names hosts not listed here.
export function sentryEnvironment(hostname = window.location.hostname) {
  const host = (hostname || '').toLowerCase();
  if (host === 'hal.infoandtech.co.uk' || host.endsWith('.emergent.host')) return 'production';
  if (host.endsWith('.preview.emergentagent.com') || host.endsWith('.emergentcf.cloud')) return 'preview';
  if (host === 'localhost' || host === '127.0.0.1') return 'development';
  return process.env.REACT_APP_SENTRY_ENVIRONMENT || 'unknown';
}

if (dsn) {
  Sentry.init({
    dsn,
    environment: sentryEnvironment(),
    release: `hal@${APP_VERSION}`,
    tracesSampleRate: 0.1,
    // Don't report the benign ResizeObserver loop errors we already suppress.
    ignoreErrors: [
      /ResizeObserver loop/,
      // rrweb (session replay) cloning PerformanceServerTiming — not app code (HAL-FRONTEND-T).
      /DataCloneError.*PerformanceServerTiming|PerformanceServerTiming.*could not be cloned/,
    ],
    initialScope: { tags: { app_role: 'frontend', hostname: window.location.hostname } },
  });
}

export { Sentry };
